import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { MeterBarWebElement } from './MeterBarWebElement';
export { MeterBarWebElement };

/**
 * Retrieve an instance of [MeterBarWebElement](../classes/MeterBarWebElement.html).
 * @example
 * ```javascript
 * import { findMeterBar } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findMeterBar(driver, By.id('my-oj-c-meter-bar'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findMeterBar(driver: DriverLike, by: By): Promise<MeterBarWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type MeterBarWebElement
  if (!(webEl instanceof MeterBarWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'MeterBarWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findMeterBar(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${MeterBarWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-meter-bar', MeterBarWebElement);
